import { render } from "./FreeChatView.vue?vue&type=template&id=5de456b6&scoped=true"
import script from "./FreeChatView.vue?vue&type=script&lang=js"
export * from "./FreeChatView.vue?vue&type=script&lang=js"

import "./FreeChatView.vue?vue&type=style&index=0&id=5de456b6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de456b6"]])

export default __exports__